import { Box, Grid } from "@mui/material";
import React, { FC, PropsWithChildren, ReactNode } from "react";

type PrivateLayoutViewProps = {
  title: ReactNode;
};

const PrivateLayoutView: FC<PropsWithChildren<PrivateLayoutViewProps>> = (props) => {
  const { title, children } = props;

  return (
    <Grid
      container
      sx={{ height: "calc(100vh - 120px)", minHeight: "500px", flexDirection: "column", flexWrap: "nowrap" }}
    >
      <Grid item>{title}</Grid>
      <Grid item sx={{ position: "relative", flex: "1 1", marginTop: "18px" }}>
        <Box sx={{ position: "absolute", top: "0", bottom: "0", left: "0", right: "0" }}>{children}</Box>
      </Grid>
    </Grid>
  );
};

export default PrivateLayoutView;
